import { render, staticRenderFns } from "./ns.vue?vue&type=template&id=2f61031c&scoped=true"
import script from "./ns.vue?vue&type=script&lang=js"
export * from "./ns.vue?vue&type=script&lang=js"
import style0 from "./ns.vue?vue&type=style&index=0&id=2f61031c&prod&scoped=true&lang=css"
import style1 from "./ns.vue?vue&type=style&index=1&id=2f61031c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f61031c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSimpleTable,VTextField})
